// extracted by mini-css-extract-plugin
export default {"address":"InvoiceTo-address_GXpIR","root":"InvoiceTo-root_p3UdS","iconBlock":"InvoiceTo-iconBlock_rkcFn","badge":"InvoiceTo-badge_gjooM","name":"InvoiceTo-name_T_udm"};